import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild, model, output, viewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ICurrentUser } from '../../models';
import { UserService } from '../../services';
import { AdminCardComponent } from '../admin-card/admin-card.component';
import { AppsCardComponent } from '../apps-card/apps-card.component';
import { HelpCardComponent } from '../help-card/help-card.component';
import { UserCardComponent } from '../user-card/user-card.component';
import { ImpersonationCurrentComponent } from '../../../../features/admin/components';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone: true,
  imports: [NgIf, NgClass
    , AppsCardComponent
    , AdminCardComponent
    , UserCardComponent
    , HelpCardComponent
    , ImpersonationCurrentComponent
  ]
})
export class TopbarComponent implements OnInit, OnDestroy {
  @Output() toggleMenu: EventEmitter<any> = new EventEmitter();
  currentUser: ICurrentUser;

  protected impersonationEmail = model('');
  public impersonateChanged = output<string>();

  // New version of viewChild problematic - with undefined, so reverted to old style
  @ViewChild(AdminCardComponent, { static: false })
  protected compMenuAdmin!: AdminCardComponent;

  @ViewChild(UserCardComponent, { static: false })
  protected compMenuUser!: UserCardComponent;

  protected destroy$ = new Subject();

  constructor(private router: Router
    , private userService: UserService) {
    this.currentUser = userService.emptyUser;
  }

  ngOnInit() {
    this.refreshUser();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  navHome() {
    this.router.navigate(['home']);
  }

  public refreshUser() {

    this.userService.getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: ICurrentUser) => {
        this.currentUser = user;
      });
  }

  public menuClick() {
    this.toggleMenu.emit(null);
  }

  protected onImpersonateChanged(email: string) {
    this.impersonationEmail.set(email);
    this.impersonateChanged.emit(email);

    this.compMenuAdmin.refreshMenu();
    this.compMenuUser.refreshUser();
  }

}
